var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colors"},[_c('CopyBox',{attrs:{"label":"RGB(A)"}},[_vm._v(" "+_vm._s(_vm.rgb)+" ")]),_vm._v(" "),_c('CopyBox',{attrs:{"label":"HEX"}},[_vm._v(" "+_vm._s(_vm.hex)+" ")]),_vm._v(" "),_c('CopyBox',{attrs:{"label":"HSL"}},[_vm._v(" "+_vm._s(_vm.hsl)+" ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f796e146","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/colors.vue
// module id = null
// module chunks = 